import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { paymentAPI } from 'redux/paymentAPI';
import { ActionState, PaymentIdObject } from '@payer-admin-ui/components-v2/src/types/state';
import { patch } from '@payer-admin-ui/components-v2/src/functions/lodashExtensions';
import { CaptureRequest } from '@payer-admin-ui/api/src/cardpayments/requests/CaptureRequest';
import { CaptureResponse } from '@payer-admin-ui/api/src/cardpayments/responses/CaptureResponse';
import { showSnackbar } from 'redux/snackbar';
import i18n from 'i18next';
import { fetchPayment } from '../paymentsGlobalState';

export const captureCardPayment = createAsyncThunk<CaptureResponse, PaymentIdObject & CaptureRequest>(
  'payments/actions/CaptureCardPaymentModal/capture',
  async ({ paymentId, type, amount, transactionDescription, releaseRemainingFunds }, { dispatch }) => {
    const result = await paymentAPI.actions.captureCardPayment({
      paymentId,
      amount,
      type,
      releaseRemainingFunds,
      transactionDescription,
    });
    dispatch(fetchPayment({ id: paymentId }));
    dispatch(
      showSnackbar(i18n.t('payments.actions.captureCardPayment.success', { paymentId }), { severity: 'success' }),
    );
    return result;
  },
);

const captureCardPaymentModalSlice = createSlice({
  name: 'payments/actions/CaptureCardPaymentModal',
  initialState: {} as ActionState,
  reducers: {
    reset: (state, { payload: { paymentId } }: PayloadAction<PaymentIdObject>) => {
      delete state[paymentId];
    },
  },
  extraReducers: builder => {
    builder.addCase(captureCardPayment.pending, (state, { meta: { arg } }) => {
      patch(state, {
        [arg.paymentId]: { isFetching: true, success: undefined, error: undefined },
      });
    });
    builder.addCase(captureCardPayment.fulfilled, (state, { meta: { arg } }) => {
      patch(state, {
        [arg.paymentId]: { isFetching: false, success: true, error: undefined },
      });
    });
    builder.addCase(captureCardPayment.rejected, (state, { meta: { arg }, error }) => {
      patch(state, {
        [arg.paymentId]: { isFetching: false, success: false, error },
      });
    });
  },
});

export const {
  actions: { reset },
  reducer: captureCardPaymentModalReducer,
} = captureCardPaymentModalSlice;
